
import { takeLatest, put, delay } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import {
	CartItem,
	CartActions,
} from 'shared/redux/cart/reducer'

const {
	setCartItems,
	showCartDialog,
	addCartStorage,
	removeCartStorage,
	loadItemsFromStorage,
	clearItemsFromStorage,
} = CartActions

const KEY = 'cartItems'

function exist(key: string) {
	try {
		return Boolean(window.localStorage.getItem(key))
	} catch(err) {
		return false
	}
}

function setStorage(key: string, data: CartItem[]) {
	try {
		window.localStorage.setItem(key, JSON.stringify(data))
	} catch(err) {}
}

function getStorage(key: string) {
	try {
		const data = window.localStorage.getItem(key)
		return JSON.parse(data ? data : '[]')
	} catch(err) {
		return []
	}
}

function removeStorage(key: string) {
	try {
		window.localStorage.removeItem(key)
	} catch(err) {}
}

function* LoadFromStorage() {
  try {
  	exist(KEY)
  		? yield put(setCartItems(getStorage(KEY)))
  		: yield put(setCartItems([]))
  	yield delay(200)
  } catch (err) {}
}

function* AddCartStorage({ payload }: PayloadAction<CartItem>) {
	try {
		let items = []

		if (!exist(KEY)) {
			setStorage(KEY, [])
		} else {
			items = getStorage(KEY)
			items = Array.isArray(items) ? items : []
		}

		setStorage(KEY, [ ...items, payload ])
		yield delay(200)
		yield put(loadItemsFromStorage())
		yield put(showCartDialog())
  } catch (err) {
  	yield put(loadItemsFromStorage())
  }
}

function* RemoveCartStorage({ payload }: PayloadAction<string>) {
	try {
		if (!exist(KEY))
			return

		const items = getStorage(KEY)
		const filtered = items.filter(({ id }: CartItem) => id !== payload)
		setStorage(KEY, filtered)
		yield put(loadItemsFromStorage())
	} catch(err) {
		yield put(loadItemsFromStorage())
	}
}

function* ClearCartStorage({ payload }: PayloadAction<string>) {
	try {
		if (!exist(KEY))
			return

		removeStorage(KEY)
		yield put(loadItemsFromStorage())
	} catch(err) {
		yield put(loadItemsFromStorage())
	}
}

function* rootSaga() {
  yield takeLatest(loadItemsFromStorage.type, LoadFromStorage)
  yield takeLatest(clearItemsFromStorage.type, ClearCartStorage)
  yield takeLatest(addCartStorage.type, AddCartStorage)
  yield takeLatest(removeCartStorage.type, RemoveCartStorage)

}

export default rootSaga
